/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Field_NameInputs */

const vi_cdo_field_name = /** @type {(inputs: Cdo_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Họ tên người nhận`)
};

/**

* @param {Cdo_Field_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_field_name = /** @type {((inputs?: Cdo_Field_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Field_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_field_name(inputs)
});